import React from 'react';
import Routes from '../_config/routes';
import GlobalStyle from '../_config/GlobalStyle';

const App = () => {
  return (
    <>
      <Routes />
      <GlobalStyle />
    </>
  );
}

export default App;
